// extracted by mini-css-extract-plugin
export default {"menuPaper":"menuPaper--T4UuI"};